import * as React from 'react';
import { memo } from 'react';

import Icon from 'components/atoms/Icon';

const CompleteIcon = () => {
	return (
		<div className="m-card__topic-icon-completed">
			<Icon iconName="completed" />
		</div>
	);
};

export default memo(CompleteIcon);
